import { ContestResponseData } from "@/restapi/contest";
import { ContestService } from "@/services/contest/contest-service";

const toText = (v: unknown): string => {
  if (typeof v === "string") return v;
  return "";
};

const ContestPeriodLabel = ({
  contest,
  locale,
}: {
  contest: ContestResponseData;
  locale: string;
}) => {
  const isEn = locale === "en";

  const label = (() => {
    if (ContestService.isFinished(contest)) {
      return isEn
        ? toText(ContestService.getClosedLabelSmart(contest, "en"))
        : toText(ContestService.getClosedLabel(contest));
    }

    if (ContestService.isScoringOpen(contest)) {
      return isEn
        ? toText(ContestService.getScoringPeriodLabelSmart(contest, { locale: "en" }))
        : toText(ContestService.getScoringPeriodLabel(contest));
    }

    if (ContestService.isSubmissionOpen(contest)) {
      return isEn
        ? toText(ContestService.getSubmissionPeriodLabelSmart(contest, { locale: "en" }))
        : toText(ContestService.getSubmissionPeriodLabel(contest));
    }

    if (ContestService.isBeforeSubmission(contest)) {
      return isEn
        ? toText(ContestService.getComingSoonLabelSmart(contest, "en"))
        : toText(ContestService.getComingSoonLabel(contest));
    }

    return "";
  })();

  return (
    <span className="text-right text-[0.75rem] text-white/70 whitespace-nowrap tabular-nums">
      {label}
    </span>
  );
};

export default ContestPeriodLabel;